import VueScrollTo from 'vue-scrollto';
import _ from 'lodash';
import { INSTANT_QUOTE_TYPES } from '@/constants';

const scrollToBottom = ({ document }) => {
  const html = document.documentElement;
  //calculate the full height of the body
  const height = Math.max(
    document.body.scrollHeight,
    document.body.offsetHeight,
    html.clientHeight,
    html.scrollHeight,
    html.offsetHeight
  );

  VueScrollTo.scrollTo(document.body, {
    easing: 'ease-in-out',
    container: document.body,
    duration: 500,
    offset: height,
  });
};

const instantQuoteLgqFilter = (quote, scheduleEventId) => {
  if (quote.type === INSTANT_QUOTE_TYPES.LONG_GRASS) {
    const { service_schedule_event_id, origin_schedule_event_id } = quote[
      INSTANT_QUOTE_TYPES.LONG_GRASS
    ];

    return (
      service_schedule_event_id === scheduleEventId || origin_schedule_event_id === scheduleEventId
    );
  }
  return false;
};

const filterInstantQuoteLongGrassByScheduleEventId = ({ instantQuotes, scheduleEventId }) => {
  if (_.isEmpty(instantQuotes) || !scheduleEventId) return {};

  const longGrassQuotes = _.filter(instantQuotes, (quote) =>
    instantQuoteLgqFilter(quote, scheduleEventId)
  );
  return !_.isEmpty(longGrassQuotes) ? longGrassQuotes[0] : {};
};

const getDefaultCycleValue = ({ cycleOptions }) => {
  const defaultCycleOption = cycleOptions.find((option) => !!option.default);
  return (defaultCycleOption || cycleOptions[0]).value;
};

// eslint-disable-next-line import/prefer-default-export
export const lsInstantQuoteFormHelpers = {
  scrollToBottom,
  filterInstantQuoteLongGrassByScheduleEventId,
  getDefaultCycleValue,
};
